import _ from "lodash";
import React from "react";
import { Button, Modal, Alert } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import { CHAT_TYPE_ENUM, KEYBOARD_SHORTCUT } from "MessagingV2/modules/Utils";
import classes from "./ChatToChannelInfoModal.scss";

const styles = {
  modalBodyStyles: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
};

const ChatToChannelInfoModal = props => {
  const { onClose, onClickNext, conversationType } = props;

  const { t } = useI18n(["common"]);

  const channelDescription = _.isEqual(
    conversationType,
    CHAT_TYPE_ENUM.CHAT_PERSONAL
  )
    ? t("common:chat_to_channel_description")
    : t("common:chat_to_channel_description_other");

  const title = _.isEqual(conversationType, CHAT_TYPE_ENUM.CHAT_PERSONAL)
    ? t("common:add_members_to_conversation")
    : t("common:add_members_to_new_channel");

  return (
    <Modal
      height="max-content"
      width="480px"
      hasOverlay
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onClose={onClose}
      isOpen
      footerSeparator
      dsVersion="2.0"
    >
      <Modal.Header title={title} isClosable hasSeparator />

      <Modal.Body style={styles.modalBodyStyles}>
        <Alert
          type="info"
          showIcon
          title={channelDescription}
          dsVersion="2.0"
        />
      </Modal.Body>
      <Modal.Footer hasSeparator>
        <div className={classes.footerContainer}>
          <Button
            variant="neutral"
            type="outlined"
            dsVersion="2.0"
            onClick={onClose}
          >
            {t("common:cancel")}
          </Button>
          <Button
            variant="progressive"
            onClick={onClickNext}
            dsVersion="2.0"
            shortcut={KEYBOARD_SHORTCUT.SHIFT_ENTER}
          >
            {t("common:next")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ChatToChannelInfoModal;
